import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'
import { isUndefined } from 'lodash'
import { FC, useMemo } from 'react'

type ErrorData = {
  detailCode: string
  message: string
}

export type Props = {
  error?: FetchBaseQueryError | SerializedError
}

const ApiError: FC<Props> = ({ error }) => {
  const errorMessage = useMemo(() => {
    if (!error) return

    if ('data' in error) {
      const data = error.data as ErrorData

      return data.message
    }

    return 'エラー'
  }, [error])

  if (isUndefined(error)) return null

  return (
    <div
      css={{
        padding: '15px',
        border: '3px solid #DF4242',
        borderRadius: '5px',
        background: '#df42425d',
      }}
    >
      <div>{errorMessage}</div>
    </div>
  )
}

export default ApiError
